import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { inputOnChange, INPUT_TRACKING_TYPES } from '../../../lib/utils';
import type { MonthlyPaymentInputProps } from '../types';
import {
  getFieldPlaceholderByCalculator,
  getFieldValueByCalculator,
} from '../utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const HomeownersInsuranceInput = (
  props: MonthlyPaymentInputProps
): JSX.Element => {
  const {
    placeholder,
    value,
    error,
    errorMessage,
    calculator,
    dispatch,
    analytics,
    label = 'Homeowners insurance',
    tooltip = 'The standard insurance policy that covers damage to your property and the things you keep in it.',
    fullWidth = true,
  } = props;

  const analyticsEnabled = analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'homeownersInsurance',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      overridesValue: 'monthlyPayments',
      overrides: true,
      legacy,
      bedrock,
      fieldName: 'homeownersInsurance',
      calculator,
      inputType: 'currency',
    });
  };

  const placeholderValue = _.isNil(placeholder)
    ? ''
    : num.formatCurrency(placeholder);
  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  return (
    <InputMoney
      label={label}
      tooltip={tooltip}
      placeholder={placeholderValue}
      value={currencyValue}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  const errorMessage = state?.validations?.homeownersInsurance?.[0];
  const error = !!errorMessage;

  return {
    error,
    errorMessage,
    value: getFieldValueByCalculator(state, calculator, 'homeownersInsurance'),
    placeholder: String(
      getFieldPlaceholderByCalculator(state, calculator, 'homeownersInsurance')
    ),
  };
};

export default connect(mapStateToProps)(HomeownersInsuranceInput);
